import BuildAlternateTexts from './alternateTexts';
import AccessibilityConfig from './configuration';
import { FC_Accessibility_SingleSeries, FC_Accessibility_SingleSeriesWithLegend } from './categories/singleSeries';
import FC_Accessibility_MultiSeries from './categories/multiSeries';

FusionCharts.addDep({
    extension: FusionCharts => {
        /**
         *
         * @param {*} chartInstance
         * @param {*} chartType
         * If anchors are turned off for line, spline, radar etc then it's not possible to highlight plots
         * As a fix to the problem, anchors are rendered with zero alpha
         *
         * Returns true if anchors are modified, otherwise return false
         */
        let adjustZeroAnchor = (chartInstance, chartType) => {
            if(chartInstance.getChartAttribute('showanchors') == '0' || (chartType && (chartType == 'area2d' || chartType == 'msarea') && chartInstance.getChartAttribute('showanchors') != "1")) {
                chartInstance.setChartAttribute({
                    'showanchors': '1',
                    'anchorbgalpha': '0',
                    'anchoralpha': '0'
                });
                return true;
            }
            return false;
        }

        let accesibilityTexts = new BuildAlternateTexts();
        let accessibilityConfig = new AccessibilityConfig();

        let Accessibility = {
            setAlternateTexts: accesibilityTexts.setAlternateTexts.bind(accesibilityTexts),
            getAlternateTexts: accesibilityTexts.getAlternateTexts.bind(accesibilityTexts)
            //setConfig: accessibilityConfig.setConfig.bind(accessibilityConfig),
            //getConfig: accessibilityConfig.getConfig.bind(accessibilityConfig)
        };

        FusionCharts.Accessibility = Accessibility;

        function addAccessibility_multiSeries(svgRoot, chartInstance, chartType) {
            let altTexts = accesibilityTexts.buildAriaTexts(chartInstance.id, 'multiSeries', chartType);
            let multiSeriesAccessibility = new FC_Accessibility_MultiSeries(svgRoot, chartInstance, altTexts, accessibilityConfig.getConfig());
            multiSeriesAccessibility.makeChartAccessible(multiSeriesAccessibility.makeMultiSeriesAccessible);
        }

        function addAccessibility_nonCartesian(svgRoot, chartInstance, chartType) {
            let altTexts = accesibilityTexts.buildAriaTexts(chartInstance.id, 'nonCartesian', chartType);
            let nonCartesianAccessibility = new FC_Accessibility_SingleSeriesWithLegend(svgRoot, chartInstance, altTexts, accessibilityConfig.getConfig());
            nonCartesianAccessibility.makeChartAccessible(nonCartesianAccessibility.makeSingleSeriesWithLegendAccessible);
        }

        function addAccessibility_singleSeries(svgRoot, chartInstance, chartType) {
            let altTexts = accesibilityTexts.buildAriaTexts(chartInstance.id, 'singleSeries', chartType);
            let singleSeriesAccessibility = new FC_Accessibility_SingleSeries(svgRoot, chartInstance, altTexts, accessibilityConfig.getConfig());
            singleSeriesAccessibility.addAxisInformation();
            singleSeriesAccessibility.makeChartAccessible(singleSeriesAccessibility.makeSingleSeriesAccessible);
        }

        FusionCharts.addEventListener('renderComplete', function(evt) {
            let chartInstance = evt.sender;
            let spanContainer = document.getElementById(evt.sender.id);

            let svgRoot = chartInstance.apiInstance.getFromEnv('paper').canvas;
            let chartType = chartInstance.chartType();

            if(svgRoot) {
                switch(chartType) {
                    case 'msline':
                    case 'msspline':
                    case 'stackedarea2d':
                    case 'msarea':
                    case 'radar':
                    case 'msstepline':
                    case 'logmsline':
                    case 'inversemsline':
                    case 'inversemsarea':
                        //Check for zero anchor and modify anchor if not shown
                        //If anchors are modified then break without adding acessibility
                        //as another render complete event will trigger
                        if(adjustZeroAnchor(chartInstance, chartType))
                            break;
                    case 'mscolumn2d':
                    case 'mscolumn3d':
                    case 'msbar2d':
                    case 'msbar3d':
                    case 'stackedcolumn2d':
                    case 'stackedcolumn3d':
                    case 'stackedbar2d':
                    case 'stackedbar3d':
                    case 'scatter':
                    case 'bubble':
                    case 'inversemscolumn2d':
                    case 'logmscolumn2d':
                    case 'logstackedcolumn2d':
                    case 'mscombi2d':
                    case 'mscombidy2d':
                        addAccessibility_multiSeries(svgRoot, chartInstance, chartType);
                        break;
                    case 'pie2d':
                    case 'pie3d':
                    case 'doughnut2d':
                    case 'doughnut3d':
                    case 'pyramid':
                    case 'angulargauge':
                        addAccessibility_nonCartesian(svgRoot, chartInstance, chartType);
                        break;
                    case 'funnel':
                        addAccessibility_nonCartesian(svgRoot, chartInstance, 'funnel');
                        break;
                    case 'line':
                    case 'spline':
                    case 'kagi':
                    case 'area2d':
                        //Check for zero anchor and modify anchor if not shown
                        //If anchors are modified then break without adding acessibility
                        //as another render complete event will trigger
                        if(adjustZeroAnchor(chartInstance, chartType))
                            break;
                    case 'column2d':
                    case 'column3d':
                    case 'bar2d':
                    case 'bar3d':
                        addAccessibility_singleSeries(svgRoot, chartInstance, chartType);
                        break;
                    case 'waterfall2d':
                        addAccessibility_singleSeries(svgRoot, chartInstance, 'waterfall2d');
                        break;
                }
            }
        });
    },
    name: 'fusioncharts-accessibility',
    type: 'extension',
    requiresFusionCharts: true
});